export default __webpack_public_path__ + "static/media/step2inprogress.25dd4dfa.png";